import { DSSpacer } from '@zoe/ds-web'
import React from 'react'

import type { SpacerRecord } from '@/types/datocms-schema'
import type { FragmentComponent } from '@/types/graphql'

const fragment = `
  fragment SpacerBlockFragment on SpacerRecord {
    __typename
    id
    size
    direction
    breakat
    dataTestId
  }
`

export const SpacerBlock: FragmentComponent<{}, SpacerRecord> = ({ record }) => {
  return (
    <DSSpacer size={record?.size} direction={record?.direction ? 'vertical' : 'horizontal'} breakAt={record?.breakat} />
  )
}

SpacerBlock.fragment = fragment
SpacerBlock.recordName = 'SpacerRecord'
